
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";
import { AuthEmailResponse, LoginInfo, handleEmailServiceError } from "./types";

/**
 * Service for login-related authentication emails
 */
export const loginService = {
  /**
   * Send a magic link for passwordless signin using Supabase's built-in functionality
   */
  async sendMagicLink(email: string): Promise<AuthEmailResponse> {
    try {
      // Use Supabase's built-in magic link functionality
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/login`,
          shouldCreateUser: false, // Only send to existing users
        }
      });

      if (error) {
        // Check if this is a rate limit error
        if (
          error.message?.toLowerCase().includes('rate limit') || 
          error.status === 429
        ) {
          return handleEmailServiceError(
            error, 
            { 
              operation: "send magic link", 
              email 
            }
          );
        }
        
        throw error;
      }
      
      logger.info({
        message: "Magic link sent successfully via Supabase",
        context: { email }
      });
      
      return { success: true };
    } catch (error) {
      return handleEmailServiceError(error, { operation: "send magic link", email });
    }
  },

  /**
   * Tracking new logins (removed email sending implementation)
   */
  async sendNewLoginEmail(email: string, loginInfo: LoginInfo): Promise<AuthEmailResponse> {
    try {
      // Just log the login attempt without sending an email through Resend
      logger.info({
        message: "New login detected",
        context: { email, loginInfo }
      });
      
      return { success: true };
    } catch (error) {
      return handleEmailServiceError(error, { operation: "log new login", email });
    }
  }
};
